import { useCallback, useState } from "react";
import { CashAndBankRepositoryImpl } from "../../data";
import {
  CashBankSummaryEntity,
  CashBankSummaryParams,
  GetCashBankSummaryUseCase,
} from "../../domain";

const repository = new CashAndBankRepositoryImpl();
const getCashBankSummaryUseCase = new GetCashBankSummaryUseCase(repository);

export const useCashBankSummary = () => {
  const [summary, setSummary] = useState<CashBankSummaryEntity | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchSummary = useCallback(async (params: CashBankSummaryParams = {}) => {
    setLoading(true);
    setError(null);

    try {
      const result = await getCashBankSummaryUseCase.execute(params);
      setSummary(result);
      return result;
    } catch (error: any) {
      setError(error.message || "Failed to load payment summary");
      throw error;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  return {
    summary,
    setSummary,
    loading,
    error,
    fetchSummary,
    clearError,
  };
};
